module.exports = __webpack_public_path__ + "corner.png?6ceb6ab3d2f121c41f13ce34dabe5680";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corner.png
// module id = 29
// module chunks = 0